import "babel-polyfill"
import "slick-carousel/slick/slick.css"
import "./src/styles/global.less"
import { MediaContextProvider } from "./src/utils/media"

export const wrapRootElement = ({ element }) => (
  <MediaContextProvider>{element}</MediaContextProvider>
)
